"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HingeEnum = void 0;
var HingeEnum;
(function (HingeEnum) {
    HingeEnum["Shoulder"] = "shoulder";
    HingeEnum["Elbow"] = "elbow";
    HingeEnum["Hip"] = "hip";
    HingeEnum["Knee"] = "knee";
})(HingeEnum = exports.HingeEnum || (exports.HingeEnum = {}));
//# sourceMappingURL=hinge.enum.js.map